/**
 * @author Maria Osama
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2018-09-04 11:58:40
 * @description Implementation of the About us react component
 * @filename about-us.tsx
 */

import React from "react";

/**
 *
 * A React component that renders the About Us.
 *
 * @extends {React.Component}
 */
export class AboutUs extends React.Component {
  /**
   * Constructor.
   *
   * @param {AboutUsProps} props The props of the component.
   */
  constructor(props: {}) {
    super(props);
  }

  /**
   * Returns a ReactNode containing the rendered component.
   *
   * @returns {React.ReactNode} The ReactNode containing the rendered component.
   */
  render(): React.ReactNode {
    return;
  }
}
